import React, { useEffect } from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, Dialog, DialogActions, DialogTitle, Grid, Paper, Typography } from '@material-ui/core'
import withServices from '../../../../hocs/withServices';
import { groupBy } from '../../../../common/groupBy';
import { ExpandMoreRounded } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';

const DormitorySelect = ({ services, contract, dormitories, fetchContract }) => {
    const [expanded, setExpanded] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [selectedRoom, setSelectedRoom] = React.useState(null);

    useEffect(() => {
        if (contract && contract.dormitoryRoomId && dormitories) {
            const selectedDormitory = dormitories.find(dormitory =>
                dormitory.rooms.some(room => room.id === contract.dormitoryRoomId)
            );
            if (selectedDormitory) {
                setExpanded(selectedDormitory.id);
            }
        }
    }, [contract, dormitories]);

    const handleClickOpen = (room) => {
        setOpen(true);
        setSelectedRoom(room);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedRoom(null);
    };

    const handleSelectRoom = () => {
        services.dormContract.selectRoom(selectedRoom.id)
            .then(() => {
                setOpen(false);
                setSelectedRoom(null);
                fetchContract();
            })
    }

    const handleExpand = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '30px',
            marginTop: '30px',
            marginBottom: '30px'
        }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <Typography variant="h5">Выбор общежития и комнаты</Typography>
                <Alert severity="info">
                    Выбрать комнату можно только 1 раз.
                </Alert>
            </div>

            <div style={{ display: 'flex', flexDirection: "column", gap: '10px' }}>
                {dormitories?.map(dormitory => (
                    <Accordion expanded={expanded === dormitory.id} variant='outlined' onChange={handleExpand(dormitory.id)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreRounded />}
                            aria-controls="panel-content"
                            id="panel-header"
                        >
                            <Typography variant="h6">{dormitory.name + " / " + dormitory.nameRu + " / " + dormitory.nameEn}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Paper key={dormitory.id} variant="outlined" square style={{ padding: '20px', width: '100%' }}>
                                <Card variant='outlined'>
                                    <CardContent>
                                        <Typography variant="body1">Количество комнат: {dormitory.roomCount}</Typography>
                                        <Typography variant="body1">Адрес: {dormitory.address}</Typography>
                                        <Typography variant="body1">Этажей: {dormitory.floorCount}</Typography>
                                        <Typography variant="body1">Лифтов: {dormitory.liftCount}</Typography>
                                        <Typography variant="body1">Парковка: {dormitory.hasParking ? 'Да' : 'Нет'}</Typography>
                                        <Typography variant="body1">Специальные туалеты: {dormitory.hasSpecialToilets ? 'Да' : 'Нет'}</Typography>
                                        <Typography variant="body1">Телефон: {dormitory.phone}</Typography>
                                        <Typography variant="body1">Годовая оплата: {dormitory.payYear}</Typography>
                                        <Typography variant="body1">Дата ремонта: {dormitory.repairDate}</Typography>
                                        <Typography variant="body1">Площадь: {dormitory.square} м²</Typography>
                                    </CardContent>
                                </Card>


                                {Object.entries(groupBy(dormitory.rooms, 'floor')).map(([floor, rooms]) => {
                                    const floorGender = dormitory.floorGenders?.find(fg => fg.floor === parseInt(floor));
                                    return (
                                        <Box key={floor} style={{ display: "flex", flexDirection: "column", width: "100%", paddingBottom: "10px" }} mt={2}>
                                            <Box style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center" }}>
                                                <Typography variant="h4">Этаж {floor} {floorGender ? `(${floorGender.gender.titleRu})` : ''}</Typography>
                                            </Box>
                                            <Grid container spacing={2}>
                                                {Object.entries(groupBy(rooms, 'flat_number')).map(([flat_number, rooms]) => (
                                                    <Grid item xs={12} sm={6} md={2} key={flat_number}>
                                                        <Typography variant="h6">Квартира {flat_number}</Typography>
                                                        {rooms.map(room => (
                                                            <Paper variant="outlined" square style={{
                                                                padding: '10px',
                                                                margin: "5px",
                                                                cursor: "pointer",
                                                                backgroundColor: contract?.dormitoryRoomId === room.id ? '#cfe8fc' : 'white'
                                                            }} key={room.id} onClick={() => (contract?.approved !== true && contract?.dormitoryRoomId === null) && handleClickOpen(room)}>
                                                                <Typography variant="body1">Комната №{room.number}</Typography>
                                                                <Typography variant="body2">Кровати: {room.beds}</Typography>
                                                            </Paper>
                                                        ))}
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Box>
                                    );
                                })}
                            </Paper>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{`Вы уверены что хотите выбрать Комнату №${selectedRoom?.number}? Выбрать комнату и общежитие можно только 1 раз.`}</DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Нет
                    </Button>
                    <Button onClick={handleSelectRoom} color="primary" autoFocus>
                        Да
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default withServices()(DormitorySelect)